import React from "react";
import PropTypes from "prop-types";
import "./Modal.scss";

const PopUpModal = ({ isOpen, onClose, message, type }) => {
  if (!isOpen) return null;

  const getTypeClass = () => {
    switch (type) {
      case "success":
        return "modal-success";
      case "error":
        return "modal-error";
      case "warning":
        return "modal-warning";
      default:
        return "modal-info";
    }
  };

  return (
    <div className="modal-overlay">
      <div className={`modal-container ${getTypeClass()}`}>
        <p className="modal-text">{message}</p>
        <button onClick={onClose} className="modal-close">Close</button>
      </div>
    </div>
  );
};

PopUpModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  message: PropTypes.string.isRequired,
  type: PropTypes.oneOf(["success", "error", "warning", "info"]),
};

PopUpModal.defaultProps = {
  type: "info",
};

export default PopUpModal;
